import { TextField, Paper, Divider, Button } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTable, StyledTableCell, StyledTableHeadCell, ButtonContainer, MeshSelect } from 'styles/admin';

export const StyledEmpTable = styled(StyledTable)`
  overflow: visible;
  table-layout: fixed;
`;

export const StyledEmpTableCell = styled(StyledTableCell)`
  overflow: hidden;
  text-overflow: ellipsis;

  padding: 9px 16px;
`;

export const StyledEmpTableHeadCell = styled(StyledTableHeadCell)`
  overflow: hidden;
  text-overflow: ellipsis;

  padding: 9px 16px;
`;

export const SkeletonContainer = styled.div`
  padding: 1.5rem 1.5rem;
  margin-top: 1.5rem;
`;

export const StyledTextField = styled(TextField)`
  margin: 0.5rem 16px;
`;

export const StyledHeaderBar = styled(Paper)`
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1rem;
`;

/* Side Panel Styled Components */

export const StyledPanelHeader = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const StyledDivider = styled(Divider)`
  margin-bottom: 1rem;
`;
export const StyledForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const StyledControl = styled.div`
  width: 48%;
  margin-bottom: 1rem;
`;
export const StyledButtonContainer = styled(ButtonContainer)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledMeshSelect = styled(MeshSelect)`
  margin-top: 9px;
`;
export const StyledButton = styled(Button)`
  width: 50%;
`;
export const StyledFullWidthContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
